export default __webpack_public_path__ + "static/media/1.5245d3ad.png";